import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { useData } from '../../../contexts/DataContext';
import * as FiIcons from 'react-icons/fi';
const { FiArrowLeft, FiTrendingUp, FiBarChart3, FiPieChart, FiActivity, FiCalendar, FiDownload } = FiIcons;
import SafeIcon from '../../../common/SafeIcon';

const SystemAnalytics = () => {
  const navigate = useNavigate();
  const { companies = [], reports = [], getAnalytics } = useData();
  const [analytics, setAnalytics] = useState(null);

  useEffect(() => {
    if (getAnalytics) {
      setAnalytics(getAnalytics());
    }
  }, [companies, reports]);

  if (!analytics) return <div className="p-8">Laster...</div>;

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow-sm border-b sticky top-0 z-10 h-16 flex items-center px-8 gap-4">
        <button onClick={() => navigate('/superadmin')} className="p-2 hover:bg-gray-100 rounded-lg"><SafeIcon icon={FiArrowLeft} /></button>
        <h1 className="text-xl font-bold">Systemanalyse</h1>
      </header>

      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
          {[
            { label: 'Rapporter', val: analytics.totalReports, icon: FiBarChart3, color: 'blue' },
            { label: 'Løste', val: analytics.reportsByStatus?.resolved || 0, icon: FiTrendingUp, color: 'green' },
            { label: 'Kritiske', val: analytics.reportsBySeverity?.critical || 0, icon: FiActivity, color: 'red' },
            { label: 'Bedrifter', val: analytics.activeCompanies, icon: FiCalendar, color: 'indigo' }
          ].map((stat, i) => (
            <div key={i} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex items-center justify-between">
              <div>
                <p className="text-xs text-gray-500 uppercase font-bold">{stat.label}</p>
                <p className="text-2xl font-black text-gray-900">{stat.val}</p>
              </div>
              <div className={`p-3 bg-${stat.color}-100 text-${stat.color}-600 rounded-lg`}>
                <SafeIcon icon={stat.icon} />
              </div>
            </div>
          ))}
        </div>

        <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100">
           <h3 className="text-lg font-bold mb-6 flex items-center gap-2">
             <SafeIcon icon={FiPieChart} className="text-blue-600" />
             Rapportfordeling
           </h3>
           <div className="space-y-4">
              {Object.entries(analytics.reportsBySeverity || {}).map(([key, val]) => (
                <div key={key}>
                   <div className="flex justify-between text-sm mb-1">
                      <span className="capitalize">{key}</span>
                      <span className="font-bold">{val}</span>
                   </div>
                   <div className="w-full bg-gray-100 rounded-full h-2">
                      <div 
                        className="bg-blue-600 h-2 rounded-full" 
                        style={{ width: `${Math.min((val / (analytics.totalReports || 1)) * 100, 100)}%` }}
                      ></div>
                   </div>
                </div>
              ))}
           </div>
        </div>
      </div>
    </div>
  );
};

export default SystemAnalytics;